import { createFileRoute } from "@tanstack/react-router";
import { Bubble } from "../../app/views/trikin/bubble";

export const Route = createFileRoute("/trikin/bubble")({
  component: Bubble,
});
